// extracted by css-extract-rspack-plugin
export default {"bui-ButtonIcon":"oswl8eimGwGMv65g","bui-ButtonIconContent":"nupI988ZoWQXN2ow","bui-ButtonIconSpinner":"S0ip8O7B0EhQCtAt","bui-spin":"wvp018_1ftcIUJUQ"};